export const API_GET_ALL_COMPANIES = "/admin/empresas/global";
export const API_GET_SEARCH_COMPANIES = "/admin/empresas/buscar";
export const API_PUT_UPDATE_COMPANY = "/admin/empresas/actualizar-subscriptionkey/";